import LinkExternal02Icon from "@redotech/redo-icons/link-external-02.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useCallback } from "react";
import { useMerchantAppLogin } from "../../../merchant-app";
import * as styles from "./merchant-app-link.module.css";

export const MerchantAppLink = memo(function MerchantAppLink({
  teamId,
  path,
  label,
}: {
  teamId: string;
  path: string;
  label: string;
}) {
  const openMerchantApp = useMerchantAppLogin();
  const handleClick = useCallback(() => {
    openMerchantApp(teamId, path);
  }, [openMerchantApp, teamId, path]);

  return (
    <Flex
      align="center"
      className={styles.container}
      gap="xxs"
      onClick={handleClick}
    >
      <Text fontSize="xs" fontWeight="medium" textColor="brand-primary">
        {label}
      </Text>
      <LinkExternal02Icon className={styles.icon} />
    </Flex>
  );
});
